import { PubModel } from '@/types/pub-models'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateDetail, {
  UseUpdateDetailOptions,
} from '../core-hooks/useUpdateDetail'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<PubModel>({
  pathCategory: 'pub_models',
})

export function useGetPubModel({
  id,
  ...options
}: UseGetDetailOptions<PubModel>) {
  const query = useGetDetail<PubModel>({
    id,
    queryKey: queryKeys.pubModels.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    pubModel: query.data,
    ...query,
  }
}

export function useGetPubModels({
  filters,
  ...options
}: UseGetListOptions<PubModel> = {}) {
  const query = useGetList<PubModel>({
    filters,
    queryKey: queryKeys.pubModels.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    pubModels: query.allData,
    ...query,
  }
}

export function useUpdatePubModel(
  options: UseUpdateDetailOptions<PubModel> = {},
) {
  const mutation = useUpdateDetail<PubModel>({
    serviceFn: service.updateDetail,
    ...options,
  })

  return {
    updatePubModel: mutation.mutate,
    updatePubModelAsync: mutation.mutateAsync,
    ...mutation,
  }
}
